import { jsxs, jsx } from "react/jsx-runtime";
import { Grid } from "@nxt-costco-com/forge-components";
import { generateContent } from "../lib.js";
function Split({
  entry,
  locale,
  columnSx = {}
}) {
  if (!entry) return null;
  const { left_composition, right_composition } = entry;
  const column1 = generateContent(
    left_composition,
    locale,
    true
  );
  const column2 = generateContent(
    right_composition,
    locale,
    true
  );
  return /* @__PURE__ */ jsxs(Grid, { container: true, children: [
    /* @__PURE__ */ jsx(Grid, { size: { xs: 12, md: 6 }, sx: columnSx, children: column1 }),
    /* @__PURE__ */ jsx(Grid, { size: { xs: 12, md: 6 }, sx: columnSx, children: column2 })
  ] });
}
export {
  Split
};
